module.exports = __webpack_public_path__ + "static/img/certification@2x.b42e1c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/certification@2x.png
// module id = 0+am
// module chunks = 1 3 4 5 6 7